import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/vsts/work/1/s/src/layers/werkenbij/src/layouts/default.vue").then(m => m.default || m))
}